import React from 'react';

import {
  Dialog,
  DialogContent,
  Button,
  Typography,
} from '@material-ui/core';


export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  text,
  secondaryText,
  confirmationButtonLabel,
  buttonColor = 'white',
  buttonBackgroundColor = 'blue',
}) {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          width: '600px',
          maxWidth: '90%',
        },
      }}
    >
      <DialogContent>
        <Typography
          variant="body1"
          display="block"
          align="center"
        >
          { text }
        </Typography>

        {
          undefined != secondaryText ?
          <Typography
            variant="body2"
            display="block"
            align="center"
            style={{
              marginTop: '0.25rem',
            }}
          >
            { secondaryText }
          </Typography> :
          null
        }
      </DialogContent>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
          <Button
            onClick={onClose}
            style={{
              margin: '0.5rem',
              borderColor: "#3B66FF",
            }}
            variant="outlined"
          >
            Cancelar
          </Button>

          <Button
            onClick={onConfirm}
            variant="contained"
            style={{
              margin: '0.5rem',
              backgroundColor: buttonBackgroundColor,
              color: buttonColor,
            }}
            disableElevation={true}
          >
            { confirmationButtonLabel }
          </Button>
        </div>
    </Dialog>
  );
}
